import React from 'react';
import { ThumbsUpIcon, AnchorIcon, DollarSignIcon, ZapIcon } from 'lucide-react';
const Partnership = () => {
  const benefits = [{
    icon: <ThumbsUpIcon className="h-8 w-8 text-white" data-id="element-247" />,
    title: 'Differentiator',
    description: 'Be the first to offer a ChatGPT alternative that works on basic phones.'
  }, {
    icon: <AnchorIcon className="h-8 w-8 text-white" data-id="element-248" />,
    title: 'Stickiness',
    description: 'Gain subscriber loyalty by giving users a useful tool.'
  }, {
    icon: <DollarSignIcon className="h-8 w-8 text-white" data-id="element-249" />,
    title: 'Revenue',
    description: 'Monetizable via freemium tiers, subscriptions, or usage-based billing.'
  }, {
    icon: <ZapIcon className="h-8 w-8 text-white" data-id="element-250" />,
    title: 'Speed',
    description: 'Ready-to-deploy platform with less than 1 month launch timeline.'
  }];
  return <section id="partnership" className="py-16 bg-[#3ba69f] text-white" data-id="element-251">
      <div className="container mx-auto px-4" data-id="element-252">
        <div className="text-center mb-16" data-id="element-253">
          <h2 className="text-3xl font-bold mb-4" data-id="element-254">
            Partner To Bring AI To Your Network
          </h2>
          <p className="text-xl text-[#e3f7f6] max-w-3xl mx-auto" data-id="element-255">
            Brands and telecom operators can white-label their own version of
            Voxie, offering customers their own useful & self-branded AI service
            and opening up new AI-enabled revenue streams.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-256">
          {benefits.map((benefit, index) => <div key={index} className="bg-[#2d8a84] p-6 rounded-lg hover:bg-[#237c76] transition-colors" data-id="element-257">
              <div className="mb-4 bg-[#54d4cb] p-3 inline-block rounded-full" data-id="element-258">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-259">{benefit.title}</h3>
              <p className="text-[#e3f7f6]" data-id="element-260">{benefit.description}</p>
            </div>)}
        </div>
        <div className="mt-16 bg-[#2d8a84] p-8 rounded-lg" data-id="element-261">
          <h3 className="text-2xl font-bold mb-6" data-id="element-262">
            Telecom Partnership Offering
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-263">
            <div data-id="element-264">
              <ul className="space-y-4" data-id="element-265">
                <li className="flex items-start" data-id="element-266">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-267">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-268">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-269" />
                    </svg>
                  </div>
                  <span data-id="element-270">
                    <span className="font-medium" data-id="element-271">Phone Number Hosting:</span>{' '}
                    Telecom provides local number(s) for SMS and voice.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-272">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-273">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-274">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-275" />
                    </svg>
                  </div>
                  <span data-id="element-276">
                    <span className="font-medium" data-id="element-277">Co-Branding:</span> Option to
                    white-label or co-brand as a telecom AI product.
                  </span>
                </li>
              </ul>
            </div>
            <div data-id="element-278">
              <ul className="space-y-4" data-id="element-279">
                <li className="flex items-start" data-id="element-280">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-281">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-282">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-283" />
                    </svg>
                  </div>
                  <span data-id="element-284">
                    <span className="font-medium" data-id="element-285">Bundling:</span> Can be
                    packaged with "Voice + SMS + Data + AI".
                  </span>
                </li>
                <li className="flex items-start" data-id="element-286">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-287">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-288">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-289" />
                    </svg>
                  </div>
                  <span data-id="element-290">
                    <span className="font-medium" data-id="element-291">Revenue Share:</span> Telecom
                    receives portion of subscription/usage revenue.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-8 bg-[#2d8a84] p-8 rounded-lg" data-id="element-292">
          <h3 className="text-2xl font-bold mb-6" data-id="element-293">
            Brand Partnership Offering
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-294">
            <div data-id="element-295">
              <ul className="space-y-4" data-id="element-296">
                <li className="flex items-start" data-id="element-297">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-298">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-299">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-300" />
                    </svg>
                  </div>
                  <span data-id="element-301">
                    <span className="font-medium" data-id="element-302">Phone Number Provision:</span>{' '}
                    We provide local number(s) for SMS and voice access.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-303">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-304">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-305">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-306" />
                    </svg>
                  </div>
                  <span data-id="element-307">
                    <span className="font-medium" data-id="element-308">White-Labeling:</span> Fully
                    branded as your company's AI assistant.
                  </span>
                </li>
              </ul>
            </div>
            <div data-id="element-309">
              <ul className="space-y-4" data-id="element-310">
                <li className="flex items-start" data-id="element-311">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-312">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-313">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-314" />
                    </svg>
                  </div>
                  <span data-id="element-315">
                    <span className="font-medium" data-id="element-316">Custom Training:</span> AI
                    assistant trained on your brand's voice and information.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-317">
                  <div className="bg-[#54d4cb] p-1 rounded-full mr-3 mt-1" data-id="element-318">
                    <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-319">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-320" />
                    </svg>
                  </div>
                  <span data-id="element-321">
                    <span className="font-medium" data-id="element-322">Subscription Model:</span>{' '}
                    Fixed monthly fee based on expected usage volume.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Partnership;